export const uiActionTypes = {
    START_ACTION: "START_ACTION",
    STOP_ACTION: "STOP_ACTION"
}